import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { Organization } from '../../app/models/Organization';
import { HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { ModalDirective } from 'ngx-bootstrap';
import { NgForm } from '@angular/forms';
import { AuthenticationService } from '../../providers/authentication/authenticationService';
import { MyApp } from '../../app/app.component';

@Component({
  selector: 'page-organization',
  templateUrl: 'organization.html',
})
export class OrganizationPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild('organizationModal')
  private organizationModal: ModalDirective;

  @ViewChild('databaseArchiviationConfirmationModal')
  private databaseArchiviationConfirmationModal: ModalDirective;

  @ViewChild('organizationForm')
  private organizationForm: NgForm;

  private pageName: string = 'page-organization';
  private organization = new Organization();
  private currentOrganization = new Organization();
  archiveDatabaseStatus: null|'inprogress'|'error' = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private authenticationService: AuthenticationService,
    private myApp: MyApp
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  ionViewWillEnter() {
    this.loadOrganizationInfo();
  }

  private loadOrganizationInfo() {
    this.backendService.getOrganization().subscribe(
      (data: Organization) => {
        this.organization = data;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  addOrganization() {
    this.currentOrganization = new Organization();
    this.organizationForm.resetForm();
    this.showOrganizationModal();
  }

  editOrganization() {
    this.currentOrganization = this.organization;
    this.showOrganizationModal();
  }

  submitOrganization(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.backendService
      .saveOrUpdateOrganization(this.currentOrganization)
      .subscribe(
        (data) => {
          this.loadOrganizationInfo();
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        btnEvent.disabled = false;
        this.closeOrganizationModal();
      });
  }

  showOrganizationModal() {
    this.organizationModal.show();
  }

  closeOrganizationModal() {
    this.organizationModal.hide();
  }

  showDatabaseArchiviationConfirmationModal() {
    this.archiveDatabaseStatus = null;
    this.databaseArchiviationConfirmationModal.show();
  }

  closeDatabaseArchiviationConfirmationModal() {
    this.databaseArchiviationConfirmationModal.hide();
  }

  archiveDatabase() {
    this.archiveDatabaseStatus = 'inprogress';
    this.backendService.dumpdb().subscribe(
      (response: HttpResponse<Blob>) => {
        const filename: string = this.getFileNameFromContentHeaders(response.headers);
        this.downloadBlob(response.body, filename);
        this.logout();
      },
      (err: HttpErrorResponse) => {
        this.archiveDatabaseStatus = 'error';
      }
    );
  }

  private downloadBlob(blob: Blob, filename: string) {
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
  }

  private getFileNameFromContentHeaders(headers: HttpHeaders): string | null {
    const contentDisposition: string | null = headers.get("Content-Disposition");
    if (!!contentDisposition) {
        // Gestione del filename* (RFC 5987)
        const fileNameStarMatch = contentDisposition.match(/filename\*\=([^;]+)/);
        if (fileNameStarMatch) {
            const encodedFileName = fileNameStarMatch[1];
            // Decodifica della stringa (URL-encoded) per ottenere il nome leggibile
            return decodeURIComponent(encodedFileName.split("''")[1]);
        }

        // Gestione del filename standard
        const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        if (fileNameMatch) {
            return fileNameMatch[1];
        }
    }
    return null;
  }

  logout() {
    this.authenticationService.logout().subscribe(
      (data) => {
        let currentIndex = this.navCtrl.getActive().index;
        this.navCtrl.push(this.myApp.rootPage).then(() => {
          this.navCtrl.remove(currentIndex);
        });
      },
      (err: HttpErrorResponse) => {
        location.reload();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/organization/organization.ts